import { Logger } from 'wdc-cube';
import { hasAnyRole } from '../../../domain';
import { RestrictedApi } from './restricted.api';
const LOG = Logger.get('Mormaii.CompanyAccess');
// @Inject
const api = RestrictedApi.INSTANCE;
export const NO_ACCESS = {};
/**
 * Pergunta ao servidor so o que os papeis pedem e ainda nao se sabe.
 *
 * As duas metades sao independentes: uma falhar nao derruba a outra, e na proxima
 * chamada so a que falhou e perguntada de novo.
 */
export async function loadCompanyAccess(roles, known = NO_ACCESS) {
    let { administered, served } = known;
    if (hasAnyRole(roles, ['ROLE_PROFESSIONAL']) && served === undefined) {
        try {
            served = await api.fetchProfessionalCompanies();
        }
        catch (caught) {
            LOG.warn('Nao foi possivel obter as empresas atendidas', caught);
        }
    }
    if (hasAnyRole(roles, ['ROLE_COMPANY_ADMIN']) && administered === undefined) {
        try {
            administered = await api.fetchMyCompanies();
        }
        catch (caught) {
            /*
             * Falhar aqui deixa a pessoa com UMA empresa em vez de duas, e nao sem
             * painel: `companyInScope` fica indefinido e o servidor resolve pela
             * unica, que e o comportamento de quem administra uma so.
             */
            LOG.warn('Nao foi possivel obter as empresas administradas', caught);
        }
    }
    return { administered, served };
}
/** Se ainda falta saber alguma metade que os papeis pedem. */
export function isIncomplete(roles, access) {
    return ((hasAnyRole(roles, ['ROLE_PROFESSIONAL']) && access.served === undefined) ||
        (hasAnyRole(roles, ['ROLE_COMPANY_ADMIN']) && access.administered === undefined));
}
//# sourceMappingURL=company-access.js.map